export default function MobileBurgerMenu() {
    // mobile burger menu
    let burger = document.querySelector('.burger-button');
    let menu_body = document.querySelector('#header-menu');
    if (burger) {
        burger.onclick = function () {
            menu_body.classList.toggle('active');
            burger.classList.toggle('active')
        }
    }
    window.addEventListener('resize', function () {
        if (window.innerWidth <= 475) {
            const header = document.querySelector('header');
            const breadcrumbsBox = document.querySelector('.breadcrumbs-box');

            if (header && breadcrumbsBox && header.classList.contains('fixed')) {
                breadcrumbsBox.style.marginTop = '150px';
            } else if (breadcrumbsBox) {
                breadcrumbsBox.style.marginTop = '10px';
            }
        }
    });

    window.dispatchEvent(new Event('resize'));

}